import Type1 from './Type1';
import Type2 from './Type2';
import Type3 from './Type3';

export default {Type1, Type2, Type3};
